import { Linking } from 'react-native';

export const openExternalLink = async (href: string): Promise<void> => {
	if (!(await Linking.canOpenURL(href))) {
		return;
	}

	await Linking.openURL(href);
};
